import {projectStageFilterOptions} from '../../forecast-app/shared/components/filters/filter_util';

const NON_PROJECT_TIME_VALUE = 'NON-PROJECT-TIME';

/** The Insights utilisation stage filter: the company's stages, then the non-project time pseudo-stage. */
export const insightsProjectStageOptions = (
	stages: ReadonlyArray<unknown>,
	showOpportunity: boolean,
	intl: {formatMessage: (descriptor: {id: string}) => string}
): {value: string; label: string}[] => [
	...projectStageFilterOptions(stages, showOpportunity, intl),
	{value: NON_PROJECT_TIME_VALUE, label: intl.formatMessage({id: 'common.non-project-time'})},
];
